import React from 'react';
import {Table} from 'antd';
import history from "../../../libs/history";
import {observer} from 'mobx-react';

import styles from './layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';


export default observer(function () {
  const {t, i18n} = useTranslation()

  const columns = [
    {
      title: t('提醒事项'),
      dataIndex: 'title',
      fixed: true,
      align: 'center',
    },
    {
      title: t('关联信息'),
      dataIndex: 'sn',
      fixed: true,
      align: 'center',
    },
    {
      title: t('提醒时间'),
      dataIndex: 'datetime',
      fixed: true,
      align: 'center',
    },
    {
      title: t('关联邮箱'),
      dataIndex: 'email',
      fixed: true,
      align: 'center',
    },
  ]

  const state = {
    selectedRowKeys: [], // Check here to configure the default column
    loading: false,
    dataSource: [
      // {
      //   id: 1,
      //   title: '设备计量提醒',
      //   sn: 'JKT23412152',
      //   datetime: '2021/04/12 13:05:12',
      //   email: 'ceshi@hotmail.com'
      // },
      // {
      //   id: 2,
      //   title: '设备计量提醒',
      //   sn: 'JTR693394111',
      //   datetime: '2021/03/25 08:30:25',
      //   email: 'ceshi@hotmail.com'
      // },
      // {
      //   id: 3,
      //   title: '设备计量提醒',
      //   sn: 'JKR20190119',
      //   datetime: '2021/03/02 02:02:02',
      //   email: 'insight@org.com'
      // },
      // {
      //   id: 4,
      //   title: '设备计量提醒',
      //   sn: 'JKR20190118',
      //   datetime: '2021/01/02 02:02:02',
      //   email: 'insight@org.com'
      // },
      // {
      //   id: 5,
      //   title: '设备计量提醒',
      //   sn: 'KLT55548811',
      //   datetime: '2021/01/01 06:50:50',
      //   email: 'ceshi@hotmail.com'
      // }
    ]
  }

  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1'].join(" ")}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('服务提醒')}</span>
        </div>
        <div className="mainBox">
          <Table className={styles.table}
                 pagination={false}
                 dataSource={state.dataSource}
                 rowKey={record => record.id}
                 columns={columns}/>


          {/*<div className={styles.innerTitle}>
            您之前求购的xxx产品有货了，快去看看吧！
            <a onClick={() => history.push('/goods')}>点击前往！</a>
          </div>*/}

          <div style={{textAlign: 'right', margin: '0.5208rem 0.026rem 0.2083rem', fontSize: "0.0625rem"}}>{t('总计')} {state.dataSource.length} {t('个记录')}</div>

        </div>


      </div>

    </React.Fragment>
  )

})
